import React from "react";
import { ItemFile } from "../../../../store/viewmodels/ItemFileViewModel";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { getFileElement } from "../../../../utils/TaskContentServices";

export interface OrganizeCardProps {
    index: number,
    place: string,
    item: Item,
    file?: ItemFile,
    setSelectedCards: React.Dispatch<React.SetStateAction<{ row: string, index: number }[]>>,
    selectedCards: { row: string, index: number }[],
    updated: boolean,
}

function OrganizeCard(props: OrganizeCardProps): JSX.Element {
    React.useEffect(() => {
        setSelected(false);
    }, [props.updated]);

    const [selected, setSelected] = React.useState(false);
    let emptyText = props.place === "firstRow" ? "X" : props.index + 1;
    let fileElement = props.file !== undefined ? getFileElement(props.file) : <div className="w-full my-auto text-center font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-teal-500 text-opacity-25">{emptyText}</div>;
    let elementButton: JSX.Element = <></>;

    const onCardClick = () => {
        if (selected) {
            setSelected(!selected);
        }
        else {
            let selCards = Array.from(props.selectedCards);
            selCards.push({ row: props.place, index: props.index })
            props.setSelectedCards(selCards)
            setSelected(!selected);
        }
    }

    let placeColor = props.place === "firstRow" ? " ring-yellow-500 text-yellow-500 hover:text-yellow-300 " : " ring-teal-500 text-teal-500 hover:text-teal-300 bg-white-300";
    let symbol = props.place === "firstRow" ? " ri-add-circle-fill" : " ri-indeterminate-circle-fill";
    let selectedColor = selected ? " ring-amber-300 text-amber-300 " : placeColor;
    let videobgColor = props.place === "firstRow" ? " bg-yellow-500" : " bg-teal-500";

    let bgColor = props.file === undefined ? " bg-white" : videobgColor;


    elementButton = (
        <div className="w-full relative p-2 lg:p-4 2xl:p-5 5xl:p-6" key={"organizeCard" + props.place + props.index} onClick={onCardClick}>
            <div key={"organizeCardButton" + props.place + "_" + props.index} className={"flex w-full h-full mx-auto overflow-hidden rounded-lg ring-4 lg:ring-8 " + selectedColor + bgColor}
                onClick={onCardClick}>
                <div className="flex w-full h-full m-auto">
                    {fileElement}
                </div>
            </div>
            <div key={""} className={"z-50 absolute -top-2 -left-1 lg:-top-2 lg:-left-2 xl:-top-3 xl:-left-3 2xl:-top-4 2xl:-left-4 5xl:-top-3 5xl:-left-3 6xl:-top-4 6xl:-left-4 8xl:-left-6 8xl:-top-7"} onClick={onCardClick}>
                <div className="relative " >
                    <span className=" text-white absolute text-3xl lg:text-5xl 2xl:text-6xl 6xl:text-7xl 8xl:text-8xl 10xl:text-9xl ri-checkbox-blank-circle-fill"></span>
                    <span className={selectedColor + " absolute text-3xl lg:text-5xl 2xl:text-6xl 6xl:text-7xl 8xl:text-8xl 10xl:text-9xl " + symbol}></span>
                </div>
            </div>
        </div>
    );

    return elementButton;
}

export default OrganizeCard;